export const getCpcStateLabel = (state: string): string => {
  switch (state) {
    case 'initiated':
      return 'در انتظار اجرا';
    case 'active':
      return 'در حال اجرا';
    case 'done':
      return 'پایان یافته';
    case 'deleted':
      return 'حذف شده';
    case 'paused':
      return 'توقف یافته';
    default:
      return state;
  }
};
